import React from 'react';
import { PixelRatio, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { ProductSubscription, ProductSubscriptionStatus } from '../../types/appsync-types';
import Typography from '../../components/Typography';
import { styles } from './sharedCardConfig';
import { useI18n } from '../../context/I18nContext';
import Spacer from '../../components/Spacer';
import GradientButton from '../../components/GradientButton';
import { AppDrawerNavigationProp } from '../../components/DrawerMenuContent';
import { screenNames } from '../../navigators/screenNames';

type Props = {
  reservation: ProductSubscription | undefined | null;
  podId: string | undefined | null;
};

export const InactiveReservationContent = ({ reservation, podId }: Props) => {
  const { I18n } = useI18n();
  const navigation = useNavigation<AppDrawerNavigationProp>();
  const hasLargeFont = PixelRatio.getFontScale() > 2;

  let reservationStatusText: string;
  switch (reservation?.status) {
    case ProductSubscriptionStatus.CANCELLING:
      reservationStatusText = I18n.t('mapview.podInfoCard.cancellingTitle');
      break;
    case ProductSubscriptionStatus.REQUIRES_ACTION:
    case ProductSubscriptionStatus.ENDED_NOT_PAID:
      reservationStatusText = I18n.t('mapview.podInfoCard.unpaidTitle');
      break;
    case ProductSubscriptionStatus.FAILED:
      reservationStatusText = I18n.t('mapview.podInfoCard.failedTitle');
      break;
    case ProductSubscriptionStatus.PROCESSING:
    default:
      reservationStatusText = I18n.t('mapview.podInfoCard.processingTitle');
      break;
  }

  return (
    <>
      <View style={[styles.scheduleSection, { flexDirection: hasLargeFont ? 'column' : 'row' }]}>
        <Typography variant={'body1'}>{reservationStatusText}</Typography>
      </View>
      <Spacer />

      {!!reservation?.productId && (
        <GradientButton
          onPress={() => {
            if (reservation?.productId) {
              navigation.navigate('map', {
                screen: screenNames.ReservationProductDetailScreen,
                params: {
                  productId: reservation.productId,
                },
              });
            } else if (podId) {
              navigation?.navigate('map', {
                screen: screenNames.OneTimePurchaseProductsScreen,
                params: {
                  filter: 'active',
                  podId,
                },
              });
            }
          }}
        >
          {I18n.t('mapview.podInfoCard.viewBooking')}
        </GradientButton>
      )}
    </>
  );
};
